import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Search, Plus } from "lucide-react";

export default function ClientsListPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [type, setType] = useState("");
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const params = {};
    if (q) params.q = q;
    if (type) params.subject_type = type;
    const r = await api.get("/subjects", { params });
    setItems(r.data.items); setTotal(r.data.total);
    setLoading(false);
  };

  useEffect(() => { load(); }, [type]);

  return (
    <div className="ma-page">
      <div className="ma-page-header">
        <h1 className="ma-h1" data-testid="clients-title">Clienti e imprese</h1>
        <Link to="/clients/new" className="ma-btn-primary-sm" data-testid="btn-new-client">
          <Plus size={16}/> Nuovo cliente
        </Link>
      </div>

      <div className="ma-filters">
        <div className="ma-search">
          <Search size={16} />
          <input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter" && load()}
                 placeholder="Cerca per nome, CF, PIVA, email…" data-testid="clients-search" />
        </div>
        <select value={type} onChange={e=>setType(e.target.value)} className="ma-input-sm" data-testid="clients-type">
          <option value="">Tutti</option>
          <option value="person">Persone</option>
          <option value="company">Imprese</option>
        </select>
        <div className="ma-total">Totale: <strong>{total}</strong></div>
      </div>

      <div className="ma-table-wrap">
        {loading ? <div className="ma-loading">Caricamento…</div> : (
          <table className="ma-table" data-testid="clients-table">
            <thead>
              <tr>
                <th>Tipo</th><th>Denominazione / Nome</th><th>CF</th><th>PIVA</th>
                <th>Email</th><th>Telefono</th><th>Stato</th><th></th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && <tr><td colSpan="8" className="ma-empty">Nessun cliente trovato.</td></tr>}
              {items.map(s => (
                <tr key={s.id} data-testid={`client-row-${s.id}`}>
                  <td><span className={`ma-pill ${s.subject_type==="company"?"pill-blue":"pill-gray"}`}>{s.subject_type==="company"?"Impresa":"Persona"}</span></td>
                  <td><Link to={`/clients/${s.id}`} className="ma-link">{s.display_name}</Link></td>
                  <td className="ma-mono">{s.fiscal_code || "—"}</td>
                  <td className="ma-mono">{s.vat_number || "—"}</td>
                  <td>{s.email || "—"}</td>
                  <td>{s.phone || "—"}</td>
                  <td><span className="ma-pill pill-status">{s.client_status}</span></td>
                  <td><Link to={`/clients/${s.id}`} className="ma-btn-link">Apri</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
